import * as React from "react";
import { FC } from 'react';
import TImeManager from "../../services/TImeManager";
import { Launch } from "@material-ui/icons";
import "./MeetingItem.css";
import { IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Firebaser from "../../services/Firebaser";
import { AssignButton } from "./AssignButton";
import { MeetingPreview } from "../../model/meetingPreview";
import { DeleteButton } from "./DeleteButton";
import { ReadyButton } from "./ReadyButton";
import { Countdown } from "./Countdown";
import { DeliveredToClientButton } from "./DeliveredToClientButton";

interface Props {
	meeting: MeetingPreview;
}

export const MeetingItem: FC<Props> = ({ meeting }) => {
	const history = useHistory();

	const enterMeeting = async () => {
		await Firebaser.getMeeting(meeting.id);
		history.push(`/meeting/${meeting.id}`);
	};

	return (
		<div className="meetingItem">
			<div className="cellItem goToMeeting"><IconButton onClick={enterMeeting} ><Launch style={{ color: 'rgb(216, 43, 66)' }} /></IconButton></div>
			<span className="cellItem meetingName">{meeting.name}</span>
			<span className="cellItem meetingLength">{meeting.lengthInSecs ? TImeManager.getTimeStringFromSecs(meeting.lengthInSecs) : ""}</span>
			<span className="cellItem meetingDate">{TImeManager.getDateString(meeting.date)}</span>
			<AssignButton meeting={meeting} />
			<ReadyButton meeting={meeting} />
			<Countdown startDate={meeting.date} endDate={meeting.dateOfReady} />
			<DeleteButton meeting={meeting} />
			<DeliveredToClientButton meeting={meeting} />
		</div>
	);
}
